import { render, staticRenderFns } from "./sim-stat.vue?vue&type=template&id=af2cc6ec&scoped=true"
import script from "./sim-stat.vue?vue&type=script&lang=js"
export * from "./sim-stat.vue?vue&type=script&lang=js"
import style0 from "./sim-stat.vue?vue&type=style&index=0&id=af2cc6ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2cc6ec",
  null
  
)

export default component.exports